import axios from 'axios';
import {
	applyAuthToAxiosConfig,
	captureAccessTokenFromUrl,
	getStoredBearerAuthorization,
	persistAccessToken,
} from './helpers/auth';
import {
	initParentAuthListener,
	requestParentTokenRefresh,
} from './helpers/parentAuth';

export const cancelSource = axios.CancelToken.source();

const redirectToMainAppLogin = () => {
	const {
		mainApp: { baseUrl, loginPagePath },
	} = window['runConfig'];
	window.location.href = `${baseUrl}${loginPagePath}?redirectUri=${encodeURIComponent(window.location.href)}`;
};

const attemptTokenRefreshViaParent = async () => {
	const { accessToken } = await requestParentTokenRefresh();
	return accessToken;
};

export const createAxiosInterceptor = () => {
	captureAccessTokenFromUrl();

	initParentAuthListener({
		onAccessTokenUpdated: persistAccessToken,
	});

	const authorization = getStoredBearerAuthorization();
	if (authorization) {
		axios.defaults.headers.common['Authorization'] = authorization;
		axios.defaults.headers.common['Cache-Control'] = 'no-cache';
	}

	axios.interceptors.request.use(
		(config) => {
			config.cancelToken = cancelSource.token;
			return applyAuthToAxiosConfig(config);
		},
		(error) => Promise.reject(error)
	);

	axios.interceptors.response.use(
		(response) => {
			window.parent.postMessage(
				JSON.stringify({ 'exp-date': response.headers['exp-date'] }),
				'*'
			);
			return response;
		},
		async (error) => {
			const originalRequest = error.config;

			if (
				error.response?.status === 401 &&
				!originalRequest?._retriedAfterRefresh
			) {
				originalRequest._retriedAfterRefresh = true;

				try {
					const newAccessToken = await attemptTokenRefreshViaParent();
					originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
					return axios(originalRequest);
				} catch (refreshError) {
					redirectToMainAppLogin();
					return Promise.reject(refreshError);
				}
			}

			if (error.response?.status === 401) {
				redirectToMainAppLogin();
			}

			return Promise.reject(error);
		}
	);
};
